"use strict";

var _interopRequireDefault = require("D:/work/dm/longda/web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = _interopRequireDefault(require("./permission"));
var install = function install(Vue) {
  Vue.directive('permission', _permission.default);
};
if (window.Vue) {
  window['permission'] = _permission.default;
  Vue.use(install); // eslint-disable-line
}
_permission.default.install = install;
var _default = exports.default = _permission.default;